import KantlistaManager from '../../../Components/Kant-Lista/KantList';

const KantList = () => {
  return (
    <div>
      <KantlistaManager />
    </div>
  );
};

export default KantList;
